import React from 'react';
import { LoadingExpressCheckoutElement } from '@shared/core/stripe';
import { useExpressCheckoutContext } from '../../ExpressCheckout.provider';
import { useTranslation } from '@shared/core';
import { TextV2 } from '@withjoy/joykit';
import { LoadingRegistryCheckoutSettings } from '@apps/registry/common/components/LoadingRegistryCheckoutSettings';
import { useEventInfo } from '@shared/utils/eventInfo';

export const ExpressCheckoutButton = () => {
  const {
    state: { giftWrap, isQuoteSettled, isDropshipCheckout },
    mutators: { handleCheckoutClick, handleCheckoutConfirm, handleCheckoutReady },
  } = useExpressCheckoutContext();
  const { t2 } = useTranslation('guestRegistry');
  const { giftWrapUneditedMessageWarning } = t2('expressCheckout');
  const { eventInfo } = useEventInfo();
  const eventId = eventInfo?.eventId;

  return (
    <>
      {giftWrap?.wrapOption === 'eCard' && !giftWrap.isMessageEdited && (
        <TextV2
          typographyVariant={'body1'}
          color={'mono12'}
          textAlign={'center'}
        >
          {giftWrapUneditedMessageWarning}
        </TextV2>
      )}
      <LoadingRegistryCheckoutSettings
        eventId={eventId}
        isDropshipCheckout={isDropshipCheckout}
      >
        <LoadingExpressCheckoutElement
          onClick={handleCheckoutClick}
          onConfirm={handleCheckoutConfirm}
          onReady={handleCheckoutReady}
          options={{ buttonHeight: 50 }}
          waitToLoad={!isQuoteSettled}
        />
      </LoadingRegistryCheckoutSettings>
    </>
  );
};
